import React from 'react';
import { useSelector } from 'react-redux';
import { Empty } from 'antd';
import Chart from 'react-apexcharts';

import { formatters } from 'services';
import { REGIONS, selectors } from 'state';

const RegionPieChart: React.FC = () => {
  const instruments = useSelector(selectors.financialInstrumentsList);
  const data = useSelector(selectors.pnlByRegion(instruments));

  if (!data.length) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }

  const series = data.map(group => group.long);
  const labels = data.map(group => {
    return REGIONS[group.region] ?? 'Unknown';
  });

  return (
    <div>
      <Chart
        series={series}
        type="pie"
        options={{
          labels,
          chart: {
            animations: {
              enabled: false,
            },
          },
          dataLabels: {
            formatter: (value: number) => value.toFixed(2) + '%',
          },
          tooltip: {
            y: {
              formatter: formatters.million,
              title: {
                formatter: (seriesName: string) => seriesName,
              },
            },
          },
        }}
      />
    </div>
  );
};

export default RegionPieChart;
